import { render, staticRenderFns } from "./NewButtons.vue?vue&type=template&id=22a6eac2&scoped=true"
import script from "./NewButtons.vue?vue&type=script&lang=js"
export * from "./NewButtons.vue?vue&type=script&lang=js"
import style0 from "./NewButtons.vue?vue&type=style&index=0&id=22a6eac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6eac2",
  null
  
)

export default component.exports